import React from "react";
import "./Admission.css";
export default function Admission() {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <img src="../Images/top.png" />
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-lg-2 col-md-2 col-sm-12"></div>
        <div className="col-lg-4 col-md-4 col-sm-12 ">
          <div className="Admissiondocimg21"></div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12 ">
          <div className="Admissiondocimg22"></div>
        </div>
        <div className="col-lg-2 col-md-2 col-sm-12"></div>
      </div>
    </div>
  );
}
